import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config";
import Button from "../Button";
import tutorial from "../../assets/tutorial.mp4";
import { postVideoFlag } from "../../services/userServices";
import { useLoaderContext } from "../../contexts/loaderContext";

const VideoTutorials = ({ onDone, fromFaq }) => {
  const [endedFlag, showEndedFlag] = useState(false);
  let { setLoader } = useLoaderContext();
  const handleEnd = () => {
    showEndedFlag(true);
  };

  const handleDone = async () => {
    setLoader(true);
    if (!fromFaq) {
      try {
        let res = await postVideoFlag();
      } catch (err) {
        console.log(err);
      } finally {
        setLoader(false);
      }
    }
    onDone();
  };

  return (
    <TutorialsContainer>
      <TutorialPanel>
        <Panel>
          {/* <ReactPlayer
            playing={true}
            controls={true}
            onEnded={() => handleEnd()}
            url="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4"
          /> */}
          <div>
            <Header>Introduction to PowerFly</Header>
            <video controls onEnded={() => handleEnd()} autoPlay playsInline>
              <source src={tutorial} type="video/mp4"></source>
            </video>
          </div>
        </Panel>

        <PanelActions>
          {(endedFlag || fromFaq) && (
            <>
              <Button
                topBottomPadding="0.75rem"
                width="10rem"
                label={"Close"}
                bgColor={Colors.brandOne}
                onClick={handleDone}
              />
            </>
          )}
        </PanelActions>
      </TutorialPanel>
    </TutorialsContainer>
  );
};

const Header = styled.div`
  padding: 1rem 0;
  color: white;
  font-size: 1.25rem;
`;
const PanelActions = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
  gap: 1rem;
  position: absolute;
  bottom: -1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.25rem;
  }
`;
const Panel = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    border-radius: 1rem;
    padding: 0;
    padding-bottom: 1rem;
    background: black;
    width: 50%;
  }
  div > video {
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 768px) {
    > div {
      width: 90%;
      padding: 0;
      background: transparent;
    }
    div > video {
      width: 80%;
    }
  }
`;

const TutorialsContainer = styled.div`
  position: absolute;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  z-index: 99999;
  justify-content: center;
  align-items: center;
  display: flex;
  top: 0;
  left: 0;
`;

const TutorialPanel = styled.div`
  position: relative;
`;

export default VideoTutorials;
